import editorModule from "./editor"
import 'ui-select'
import 'angular-sanitize'
import 'angular-ui-notification'
angular.module('editor', ['ui.select', 'ngSanitize', 'ui-notification'])
  .config([
    'NotificationProvider',
    function(notificationProvider){
      notificationProvider.setOptions({
        positionX: 'center'
      });
    }
  ]);
editorModule();
